import ExtraPriceDetails from "app/pages/Booking/Quotation/PriceDetails/ExtraPriceDetails/ExtraPriceDetails";
import {
	checkForSpecialOffer,
	getCurrentPaymentMode,
	getEcheancier,
} from "app/pages/Booking/Payment/paymentSelector";
import { getIncludedTransfer } from "app/pages/Booking/Quotation/quotationSelectors";
import { PAYMENT_COUPON_TYPE, TRANSPORTATION_TYPES } from "app/constants";
import {
	getUsableCreditNotesTotal,
	getUsableCreditsTotal,
	getAvailableCreditsTotal,
} from "app/pages/Account/MyCoupons/couponSelector";
import { connect } from "react-redux";
import withRouter from "app/utils/hocs/withRouter";
import { getLuggageTotalPrice } from "app/pages/Booking/bookingSelectors";
import { getSelectedActivitiesForPriceDetails } from "app/pages/Booking/Quotation/Activity/QuotationActivitySelectors";
import { getSpecialOffer } from "app/pages/FicheProduit/ficheProduitSelector";
import {
	getSelectedTransportType,
	calculateQuoteBaseAndExtrasTotal,
} from "app/pages/Booking/bookingSelectors";
import {
	checkIsCreditNoteUsageIsEnabled,
	checkIsCreditUsageIsEnabled,
} from "app/reducers/partnerSelector";

const mapStateToProps = (state, ownProps) => {
	const booking = state.booking;
	// ownProps.match.url does not work here for holiday summary on mobile for example where ownProps.match.url = "booking"
	const isPagePayment =
		ownProps.location.pathname.includes("/booking/payment") ||
		ownProps.location.pathname.includes("/booking/restoreSession");
	const mensualite = getEcheancier(state);
	const selectedTransportType = getSelectedTransportType(state);
	const isPageQuote = ownProps.location.pathname.includes("/booking/quote");

	return {
		includedTransfer: getIncludedTransfer(state),
		luggage: booking.luggage,
		luggageTotalPrice: getLuggageTotalPrice(state),
		accommodation: booking.accommodation,
		transfer: booking.transfer,
		offer: booking.offer,
		board: booking.board,
		flight: booking.flight,
		adults: booking.adults,
		infants: booking.infants,
		insurance: booking.insurance,
		totalUsableCredit:
			booking.coupon === PAYMENT_COUPON_TYPE.CREDIT ? getUsableCreditsTotal(state) : 0,
		totalUsableCreditNote: getUsableCreditNotesTotal(state),
		promotionValue:
			booking.coupon === PAYMENT_COUPON_TYPE.PROMOCODE ? state.promotion.promotionValue : 0,
		isPagePayment,
		isPageQuote,
		coutCredit: mensualite.coutCredit,
		selectedPaymentMode: getCurrentPaymentMode(state),
		activities: getSelectedActivitiesForPriceDetails(state),
		usableCouponsStatus: state.usableCoupons.status,
		specialOffer: getSpecialOffer(state),
		isSpecialOfferActive: checkForSpecialOffer(state),
		isSelectedTransportTrain: selectedTransportType === TRANSPORTATION_TYPES.TRAIN,
		creditsAmount: getAvailableCreditsTotal(state),
		prebookTotal: calculateQuoteBaseAndExtrasTotal(state),
		isCreditEnabled: checkIsCreditUsageIsEnabled(state),
		isCreditNoteEnabled: checkIsCreditNoteUsageIsEnabled(state),
	};
};

export default withRouter(connect(mapStateToProps)(ExtraPriceDetails));
